module.exports = __webpack_public_path__ + "img/level_two.389bcd1f.png";